import {
    NUDGES_ICON_SIZES,
    REWARDS_DISCOUNT_TYPE,
} from "@modules/nudges/types";
import {
    array,
    assign,
    enums,
    literal,
    nullable,
    number,
    object,
    string,
    union,
} from "superstruct";

import { RewardsCustomerRewardSchema } from "./RewardsCustomerRewardSchema";

const NudgesIconSchema = object({
    url: string(),
    sizes: array(
        object({
            method: string(),
            w: number(),
            h: number(),
            url: string(),
            label: enums(Object.values(NUDGES_ICON_SIZES)),
        })
    ),
});

export const RewardsActivitySchema = object({
    id: number(),
    title: string(),
    icon: nullable(NudgesIconSchema),
});

const RewardsCustomerRewardsBaseSchema = object({
    id: number(),
    reward: RewardsCustomerRewardSchema,
    createdAt: string(),
});

const RewardsCustomerRewardsEarningRuleSchema = assign(
    RewardsCustomerRewardsBaseSchema,
    object({
        type: literal(REWARDS_DISCOUNT_TYPE.REWARD),
        earningRule: RewardsActivitySchema,
    })
);

const RewardsCustomerRewardsSpendingRuleSchema = assign(
    RewardsCustomerRewardsBaseSchema,
    object({
        type: literal(REWARDS_DISCOUNT_TYPE.REDEEM),
        spendingRule: RewardsActivitySchema,
    })
);

const RewardsCustomerRewardsTierSchema = assign(
    RewardsCustomerRewardsBaseSchema,
    object({
        type: literal(REWARDS_DISCOUNT_TYPE.TIER),
        tier: RewardsActivitySchema,
    })
);

const RewardsCustomerRewardsReferredSchema = assign(
    RewardsCustomerRewardsBaseSchema,
    object({
        type: literal(REWARDS_DISCOUNT_TYPE.REFERRED),
        referred: object({
            title: string(),
            icon: nullable(NudgesIconSchema),
        }),
    })
);

const RewardsCustomerRewardsReferrerSchema = assign(
    RewardsCustomerRewardsBaseSchema,
    object({
        type: literal(REWARDS_DISCOUNT_TYPE.REFERRER),
        referrer: object({
            title: string(),
            icon: nullable(NudgesIconSchema),
        }),
    })
);

export const RewardsCustomerRewardsSchema = union([
    RewardsCustomerRewardsEarningRuleSchema,
    RewardsCustomerRewardsSpendingRuleSchema,
    RewardsCustomerRewardsTierSchema,
    RewardsCustomerRewardsReferredSchema,
    RewardsCustomerRewardsReferrerSchema,
]);
